module.exports = __webpack_public_path__ + "img/loading.baeaf0c7.gif";